export const DEVICE_ID = "device-id";
export const SETTINGS_PREFIX = "cassis-reader";
export const TRACKER_PREFIX = "cassis-tracker";
export const annotationEvents = {
  BookmarkCreated: "bookmarkCreated",
  BookmarkDeleted: "bookmarkDeleted",
};

export const readerEvents = {
  PageTurnBackward: "pageTurnBackward",
  PageTurnForward: "pageTurnForward",
  Reflow: "reflow",
  Scroll: "scroll",
  OrientationPortrait: "orientationPortrait",
  OrientationLandscape: "orientationLandscape",
  TocOpen: "tocOpen",
  TocClosed: "tocClosed",
  EnterFullscreen: "enterFullscreen",
  ExitFullscreen: "exitFullscreen",
};
export const trackerEvents = {
  Started: "started",
  Paused: "paused",
  ModalPaused: "modalActive:paused",
  Resumed: "resumed",
  ModalResumed: "modalClosed:resumed",
  TocNav: "tocNav",
  BackNav: "backNav",
  BookmarkNav: "bookmarkNav",
  Stopped: "stopped",
  Completed: "completed",
  Terminated: "terminated",
  Hibernated: "hibernated",
};
export const settingsKeys = {
  SELECTED_FONT_KEY: "settings-selected-font",
  SELECTED_FONT_SIZE_KEY: "settings-selected-font-size",
  SELECTED_LINE_HEIGHT_KEY: "settings-selected-line-height",
  SELECTED_THEME_KEY: "settings-selected-theme",
  SELECTED_VIEW_KEY: "settings-selected-view",
  VIEW_LOCK_KEY: "settings-locked-view",
  SELECTED_RETAILER_KEY: "settings-selected-retailer",
  SELECTED_MARGIN_KEY: "settings-selected-margin",
  SELECTED_GUIDE_KEY: "settings-selected-guide",
  SELECTED_ALIGNMENT_KEY: "settings-selected-alignment",
  SELECTED_MODE_KEY: "settings-selected-mode",
};
